"use client";

import { useEffect, useRef, useState } from "react";

const POLL_INTERVAL = 100;
const POLL_TIMEOUT = 10000;

/**
 * Polls for an external SDK global to become available, then runs an init function.
 * @param {() => boolean} checkFn - Returns true when the SDK global is available
 * @param {() => void} initFn - Called once when SDK is detected
 * @returns {boolean} sdkReady
 */
export default function useExternalSDK(checkFn, initFn) {
  const isInitialized = useRef(false);
  const [sdkReady, setSdkReady] = useState(false);

  useEffect(() => {
    let elapsed = 0;
    const poll = setInterval(() => {
      elapsed += POLL_INTERVAL;
      if (checkFn() && !isInitialized.current) {
        clearInterval(poll);
        try {
          initFn();
          isInitialized.current = true;
          setSdkReady(true);
        } catch {
          /* SDK init failed */
        }
      } else if (elapsed >= POLL_TIMEOUT) {
        clearInterval(poll);
      }
    }, POLL_INTERVAL);

    return () => clearInterval(poll);
  }, []);

  return sdkReady;
}
